import { IMainState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { IState } from '../state';

export const getters = {
  hasAdminAccess: (state: IMainState) => {
    return (
      state.userProfile &&
            state.userProfile.is_superuser && state.userProfile.is_active);
  },
  loginError: (state: IMainState) => state.logInError,
  dashboardShowDrawer: (state: IMainState) => state.dashboardShowDrawer,
  dashboardMiniDrawer: (state: IMainState) => state.dashboardMiniDrawer,
  userProfile: (state: IMainState) => state.userProfile,
  token: (state: IMainState) => state.token,
  isLoggedIn: (state: IMainState) => state.isLoggedIn,
  firstNotification: (state: IMainState) => state.notifications.length > 0 && state.notifications[0],
};

const {read} = getStoreAccessors<IMainState, IState>('');

export const readDashboardMiniDrawer = read(getters.dashboardMiniDrawer);
export const readDashboardShowDrawer = read(getters.dashboardShowDrawer);
export const readHasAdminAccess = read(getters.hasAdminAccess);
export const readIsLoggedIn = read(getters.isLoggedIn);
export const readLoginError = read(getters.loginError);
export const readToken = read(getters.token);
export const readUserProfile = read(getters.userProfile);
export const readFirstNotification = read(getters.firstNotification);
